export default "__VITE_ASSET__CfV$uwyq__"